import { Controller } from "@hotwired/stimulus"

const DEFAULT_ERROR =
  "You entered in an incorrect email or password,please try again."

// Login via fetch — no full-page reload, no loader flash; errors as toast (matches React).
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.busy = false
    this.redirecting = false
    this.defaultSubmitLabel = this.hasSubmitTarget
      ? this.submitTarget.value || this.submitTarget.textContent
      : "Log In"
  }

  submit(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    if (!this.element.checkValidity()) return
    if (this.busy) return

    this.busy = true
    void this.signIn()
  }

  async signIn() {
    this.setSubmitBusy(true)

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData(this.element)

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          ...(token ? { "X-CSRF-Token": token } : {}),
        },
        credentials: "same-origin",
      })

      const data = await response.json().catch(() => ({}))

      if (response.ok && data.redirect_url) {
        window.location.assign(data.redirect_url)
        return
      }

      if (data.shopify_admin_url) {
        this.redirectToShopifyAdmin(data)
        return
      }

      this.showToast(
        this.normalizeMessages(data.message),
        data.messageType || "error",
      )
    } catch (_error) {
      this.showToast(["Something went wrong ! try again later."], "error")
    } finally {
      if (!this.redirecting) {
        this.busy = false
        this.setSubmitBusy(false)
      }
    }
  }

  redirectToShopifyAdmin(data) {
    this.redirecting = true
    this.showToast(
      this.normalizeMessages(data.message),
      data.messageType || "info",
    )
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.value = "Redirecting to Shopify..."
    }
    window.setTimeout(() => {
      window.location.assign(data.shopify_admin_url)
    }, 2500)
  }

  setSubmitBusy(busy) {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = busy
    if (busy) {
      this.submitTarget.value = "Logging in..."
    } else {
      this.submitTarget.value = this.defaultSubmitLabel
    }
  }

  normalizeMessages(message) {
    if (Array.isArray(message)) return message.filter(Boolean)
    if (message) return [message]
    return [DEFAULT_ERROR]
  }

  showToast(message, messageType) {
    document.dispatchEvent(
      new CustomEvent("auth:toast", {
        detail: { message, messageType },
      }),
    )
  }
}
